/**
 * Regular expression pattern for matching words consisting of alphabetic characters or numbers.
 */
export const wordsRegex = /[A-Za-z][a-z]*|[0-9]+/g;
//# sourceMappingURL=shared.js.map